import React from 'react';
import Icon from '../../Components/Icons/Icon';
import menu from '../menu';
import { Link, useLocation } from 'react-router-dom';
import { useSession } from '../../Components/Session';
import { useHelp } from '../../Components/Help';
import { useDialogues } from '../../Components/Dialogues';
import { classNames } from '../../Services/helpers';
import { levels } from '../../Data/Admin';

export default (props) => {
    const path = useLocation().pathname;
    const subtabs = menu.items.find((item) => path.match(item.match))?.subitems ?? [];

    const {notificationBadge, hasFeature, isRoleSufficient, isAdminSwitched, adminSwitchBack, isAdmin} = useSession();
    const {unreadMessages} = useHelp();

    return <div className="fixed bottom-0 left-0 w-full shadow-lg z-20" style={{boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)'}}>
        {isAdminSwitched && <div className="bg-red-500 text-white font-bold text-center py-1 text-xs"
            onClick={() => adminSwitchBack()}
        >
            Switch back
        </div>}
        <div className="bg-white shadow-lg text-blue-900" id="tab-container">

            <div className="flex flex-row text-center bg-blue-100 overflow-x-auto">
                {subtabs.map((item, index) => {
                    return <Subtab key={item.title}
                                title={item.title}
                                path={item.path}
                                active={path.match(item.match)}
                                feature={item.feature}
                                role={item.role}
                            />
                })}
            </div>

            <div className="flex flex-row text-center">
                {menu.items.map((item, index) => {
                    if (item.adminOnly && !isAdmin(levels.READ_ONLY)) {
                        return null;
                    }

                    if (item.role && !isRoleSufficient(item.role)) {
                        return <LockedTab key={item.title} title={item.title} icon={item.icon} role={item.role} />;
                    }

                    let badge = false;
                    if (item.notificationBadge) {
                        badge = notificationBadge ? notificationBadge : false;
                    } else if (item.helpMessageBadge) {
                        badge = unreadMessages ? unreadMessages : false;
                    }

                    return <Tab key={item.title}
                                title={item.title}
                                icon={item.icon}
                                path={selectTabPath(item, hasFeature)}
                                active={path.match(item.match)}
                                badge={badge}
                                isAdminSwitched={isAdminSwitched}
                            />
                })}
            </div>
        </div>
    </div>
}

const selectTabPath = (item, hasFeature) => {
    return item.path ?? item.subitems.find((subitem) => !subitem.feature || hasFeature(subitem.feature))?.path;
}

const Tab = ({ title, icon, path, active, badge }) => {
    return <Link to={path} className={classNames(
            'w-1/5 py-2 ',
            active ? 'bg-blue-100 text-black fill-black font-bold' : 'fill-blue-900',
        )}>
        <div className="h-7 w-6 m-auto relative">
            <Icon icon={icon} theme="light" size="2x" badge={badge} />
        </div>
        <span className="block text-xs">{title}</span>
    </Link>
}

const LockedTab = ({ title, icon, role }) => {
    const {roleInsufficient} = useDialogues();
    return <div className={'w-1/5 py-2 fill-muted'} onClick={() => roleInsufficient(role)}>
        <div className="h-7 w-6 m-auto relative">
            <Icon icon={icon} theme="light" size="2x" />
        </div>
        <span className="block text-xs text-muted">{title}</span>
    </div>
}

const Subtab = ({ title, path, active, feature, role }) => {
    const {hasFeature, isRoleSufficient} = useSession();
    const {featureUnavailable, roleInsufficient} = useDialogues();
    let element = <Link to={path} className="block text-s">{title}</Link>;

    if ((feature && !hasFeature(feature)) || (role && !isRoleSufficient(role))) {
        element = <span className="block text-s text-muted fill-muted break-keep text-nowrap"
            onClick={() => (feature && !hasFeature(feature)) ? featureUnavailable(feature) : roleInsufficient(role)}
        >
            {title} <Icon icon="Lock" className="ml-1" inline />
        </span>;
    }

    return <div className={classNames('grow py-1 px-2 max-h-[2rem] overflow-hidden', active && 'font-bold text-black')}>
        {element}
    </div>
}
